// extracted by mini-css-extract-plugin
export default {"card":"OpenSourceCard_card__fFaGU","colored":"OpenSourceCard_colored__h2JFs"};